// extracted by mini-css-extract-plugin
module.exports = {"filterWrapper":"Filters_filterWrapper__2BfqX","filterTitle":"Filters_filterTitle__1Ee28"};